export default __webpack_public_path__ + "media/images/images/slider/slider-3-4dc086d6a0519e1dd0fd3b73d9b26f5e.png";